import { AfterViewInit, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { PageNames } from '../../../shared/page-names.enum';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { ModalConfig } from '../../../model/modal-config';
import { Order } from '../../../model/order';
import { ResourceService } from '../../../services/resource/resource.service';
import { OmapiIdConstants } from '../../../shared/omapi-id-constants';
import { QrCodeTypeEnum } from '../../../enums/streaming-bundles/qr-code-type.enum';
import { TvShopStateService } from '../../../services/state/tv-shop-state.service';
import { OmapiIdsUtils } from '../../../shared/utils/omapi-ids/omapi-ids-utils';
var OrderSucceededComponent = /** @class */ (function () {
    function OrderSucceededComponent(navigationService, changeDetector, resourceService, stateService) {
        this.navigationService = navigationService;
        this.changeDetector = changeDetector;
        this.resourceService = resourceService;
        this.stateService = stateService;
        this.componentName = PageNames.ORDERING_SUCCEEDED;
        this.emitCloseOrderSucceeded = new EventEmitter();
        this.emitOnBack = new EventEmitter();
        this.isSubscribedStreamingPack = false;
        this.pack = this.stateService.selectSnapshot(function (state) { return state.basket.selectedTvShopEntertainmentPack; });
        this.setSubscribedStreamingPackState();
    }
    OrderSucceededComponent.prototype.ngAfterViewInit = function () {
        this.navigationService.resetNavigation();
        this.setLogoUrl();
    };
    OrderSucceededComponent.prototype.setLogoUrl = function () {
        if (this.order.type === Order.DAYPASS) {
            this.logoUrl = this.resourceService.getLogoUrl(OmapiIdConstants.PLAY_SPORTS, undefined, false);
        }
        else {
            this.logoUrl = this.resourceService.getLogoUrl(this.order.packOmapiId, this.order.subPackOmapiId, false);
        }
        this.changeDetector.detectChanges();
    };
    OrderSucceededComponent.prototype.onEmitCloseOrderSucceeded = function () {
        this.emitCloseOrderSucceeded.emit({
            omapiId: this.order.packOmapiId
        });
    };
    OrderSucceededComponent.prototype.onBack = function () {
        this.emitOnBack.emit({
            value: true
        });
    };
    OrderSucceededComponent.prototype.getPackageName = function () {
        return this.order.packOmapiId === OmapiIdConstants.RED_CARPET_MORE ? OmapiIdConstants.COM_NAME_RED_CARPET_MORE : this.order.orderName();
    };
    OrderSucceededComponent.prototype.setSubscribedStreamingPackState = function () {
        if ((this.pack.isStreamingBundle || this.pack.isStreamingStandaloneProduct || this.pack.isGroupPack) &&
            this.pack.subscribed) {
            this.isSubscribedStreamingPack = true;
            if (this.pack.omapiId === OmapiIdsUtils.DISNEY_PLUS_ID) {
                this.qrTitle = 'eos-tv-shop-ii.title.qr-tile-disney-plus';
                this.qrDescription = 'eos-tv-shop-ii.text.qr-tile-description-disney-plus';
                this.qrCodeType = QrCodeTypeEnum.ACTIVATE_DISNEY;
            }
            else {
                this.qrTitle = 'eos-tv-shop-ii.title.qr-tile-netflix';
                this.qrDescription = 'eos-tv-shop-ii.text.qr-tile-description-netflix';
                this.qrCodeType = QrCodeTypeEnum.ACTIVATE_NETFLIX;
            }
        }
    };
    return OrderSucceededComponent;
}());
export { OrderSucceededComponent };
